import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=5bc1b826&scoped=true&"
import script from "./ScrollBar.vue?vue&type=script&lang=js&"
export * from "./ScrollBar.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=5bc1b826&prod&lang=stylus&scoped=true&"
import style1 from "./ScrollBar.vue?vue&type=style&index=1&id=5bc1b826&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1b826",
  null
  
)

export default component.exports